/**
 * @file 业务相关
 */
import Tool from '../utils/tool';

export default {

/**
 * 拼接好看iOS吊起通用链接,可直接进行吊起
 *
 * @private
 * @param {string} id 视频的locid
 * @param {Object} source 额外的参数,主要用于统计
 * @return {string} baseUrl 好看的吊起通链
 */
    createHaokanDetailULink: ({id, source, failUrl}) => {
        let baseUrl = `http://wapsite.baidu.com/haokan/share/detail?url_key=${encodeURIComponent(id)}`;
        if (failUrl) {
            baseUrl += `&target=${encodeURIComponent(failUrl)}`;
        }
        if (Tool.isObject(source)) {
            Object.keys(source).map(key => {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    baseUrl += `&${key}=${source[key]}`;
                }
                return false;
            });
        }
        return baseUrl;
    },

    /**
 * 拼接好看Android吊起scheme,可直接进行吊起
 *
 * @private
 * @param {string} id 视频的locid
 * @param {Object} source 额外的参数,主要用于统计
 * @return {string} baseUrl 好看的吊起scheme
 */
    createHaokanDetailScheme: ({id, source}) => {
        let baseUrl = `baiduhaokan://video/details/?url_key=${encodeURIComponent(id)}`;
        if (Tool.isObject(source)) {
            Object.keys(source).map(key => {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    baseUrl += `&${key}=${source[key]}`;
                }
                return false;
            });
        }
        return baseUrl;
    }
};
